import styled, { css } from "styled-components";
import { type WidthProps, width } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as CheckboxStyle from "../../../../../../../common-deprecated/styles/v2/toyota/components/Input";
import { focusStyle } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";

// List
export const List = styled.ul.attrs(() => ({
    className: "list-unstyled",
}))`
    padding-left: 0;
    &:not(:last-of-type) {
        margin-bottom: ${theme.space[4]}px !important; /* Added an !important to override Foundation team CSS */
    }

    html[dir="rtl"] & {
        padding-right: 0;
    }
`;

export const ListItem = styled.li<WidthProps>`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${theme.space[3]}px !important; /* Added an !important to override Foundation team CSS */
    ${width};

    &:last-child {
        margin-bottom: 0px !important;
    }
`;

// Checkbox style
// eslint-disable-next-line prefer-destructuring
export const Wrapper = styled(CheckboxStyle.Wrapper)`
    ${focusStyle};
`;

export const Checkbox = styled(CheckboxStyle.Checkbox)<{ disabled?: boolean }>`
    display: inline-block;
    @supports (text-wrap: balance) {
        text-wrap: balance;
    }
    ${(props) =>
        props.disabled &&
        css`
            color: ${theme.colors.grey3};
            cursor: default;
        `}
`;

export const Counter = styled.span`
    color: ${theme.colors.grey4};
`;
